import { useStateContext } from "@client/pages/round/Round";
import { useEffect, useState } from "react";

export function useAllFieldResponses(): Record<string, Record<string, string>> {
  const { infoStore } = useStateContext();
  const [fieldResponses, setFieldResponses] = useState<
    Record<string, Record<string, string>>
  >(() => infoStore.getAllFieldResponses());

  useEffect(() => {
    const unsubscribe = infoStore.subscribeToAllFieldResponses(
      (fieldResponses) => {
        setFieldResponses(fieldResponses);
      },
    );

    return unsubscribe;
  }, [infoStore]);

  return fieldResponses;
}

export function useFieldResponsesForProposal(
  proposalId: string,
): Record<string, string> {
  const { infoStore } = useStateContext();
  const [fieldResponses, setFieldResponses] = useState<Record<string, string>>(
    () => infoStore.readNewestFieldResponses(proposalId) ?? {},
  );

  useEffect(() => {
    if (!proposalId) return;
    const unsubscribe = infoStore.subscribeToFieldResponses(
      proposalId,
      (fieldResponses) => {
        setFieldResponses(fieldResponses);
      },
    );

    return unsubscribe;
  }, [proposalId, infoStore]);

  return fieldResponses;
}
